// Swaps a product card's image when one of its colour swatches is clicked.
// Uses a delegated listener so it keeps working after facets replace the grid.
(function () {
  if (window.colourSwatchesInitialized) return;
  window.colourSwatchesInitialized = true;

  const SELECTED_CLASS = 'colour-swatches__link--selected';
  const CURRENT_CLASS = 'colour-swatches__link--current';

  function swapCardMedia(link) {
    const card = link.closest('.card-wrapper');
    if (!card) return false;

    const images = card.querySelectorAll('.card__media img');
    const image = images[0];
    if (!image) return false;

    // The secondary hover image still belongs to the original product. It is
    // only hidden by `.media--hover-effect > img + img`, so it has to go.
    for (let i = 1; i < images.length; i++) images[i].remove();

    image.setAttribute('src', link.dataset.swatchMediaSrc);
    image.setAttribute('alt', link.dataset.swatchMediaAlt || '');
    if (link.dataset.swatchMediaSrcset) {
      image.setAttribute('srcset', link.dataset.swatchMediaSrcset);
    } else {
      image.removeAttribute('srcset');
    }

    const url = link.getAttribute('href');
    card.querySelectorAll('a.full-unstyled-link').forEach(function (cardLink) {
      cardLink.setAttribute('href', url);
    });

    if (link.dataset.swatchTitle) {
      card.querySelectorAll('.card__heading a').forEach(function (heading) {
        heading.textContent = link.dataset.swatchTitle;
      });
    }

    const priceTemplate = link.parentElement.querySelector('template[data-swatch-price]');
    const currentPrice = card.querySelector('.card-information .price');
    if (priceTemplate && currentPrice) {
      const newPrice = priceTemplate.content.firstElementChild;
      if (newPrice) currentPrice.replaceWith(newPrice.cloneNode(true));
    }

    const list = link.closest('[data-swatch-card-media]');
    list.querySelectorAll('.colour-swatches__link').forEach(function (sibling) {
      sibling.classList.remove(SELECTED_CLASS, CURRENT_CLASS);
      sibling.removeAttribute('aria-current');
    });
    link.classList.add(SELECTED_CLASS);
    link.setAttribute('aria-current', 'true');

    return true;
  }

  function showMoreSwatches(button) {
    const list = button.closest('.colour-swatches__list');
    const extras = list.querySelectorAll('[data-swatch-extra]');
    extras.forEach(function (item) {
      item.hidden = false;
    });
    button.closest('.colour-swatches__item--more').remove();

    const firstLink = extras[0] && extras[0].querySelector('.colour-swatches__link');
    if (firstLink) firstLink.focus();
  }

  document.addEventListener('click', function (event) {
    const moreButton = event.target.closest('[data-swatch-more]');
    if (moreButton) {
      event.preventDefault();
      showMoreSwatches(moreButton);
      return;
    }

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    const link = event.target.closest(
      '[data-swatch-card-media] .colour-swatches__link[data-swatch-media-src]'
    );
    if (!link) return;

    // Without a card image to swap, let the link navigate as normal.
    if (swapCardMedia(link)) event.preventDefault();
  });
})();
